<script setup lang="ts">
import { keys } from "~/utilities/injection"

defineProps({
  showSuggestions: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
})

const article = inject(keys.currentArticle)
const { data: suggestedSolutionsData } = useMathTaskSolutions(article)

const assignments = computed(() => article?.value?.mathTask?.assignments || [])
</script>

<template>
  <ol
    v-if="assignments.length > 1"
    class="flex flex-col gap-4 pl-2 md:pl-5"
  >
    <li
      v-for="assignment in assignments"
      :key="assignment.id"
    >
      <UMathTaskAssignment
        :assignment="assignment"
        :show-suggestions="showSuggestions"
      />
    </li>
  </ol>
  <div v-else-if="assignments.length === 1">
    <UMathTaskAssignment
      :assignment="assignments[0]!"
      :show-suggestions="showSuggestions"
      :show-assignment-in-suggestion="false"
    />
  </div>
  <div
    v-if="
      showSuggestions &&
      !suggestedSolutionsData?.suggestedSolutions.size
    "
  >
    <p class="py-6">
      Vi klarte ikke å hente hele løsningsforslaget.
      <UContactCustomerService /> om feilen vedvarer.
    </p>
  </div>
</template>
